import { Form } from 'utils/hooks'
import { Flex } from 'components/shared/flex'
import { OvaryTestResultV2Form } from 'api/result'
import { CheckboxField, DateField, InputField, MultipleSelectField, RangeField } from 'components/shared/input'
import { ProductItem } from 'entities/product_item'
import { Symptom } from '../result_v2'

type OvaryTestViewProps = {
    form: Form<OvaryTestResultV2Form>
    formPrev: Form<OvaryTestResultV2Form>
    formPrev2: Form<OvaryTestResultV2Form>
    productItem: ProductItem
    symptoms: Symptom[]
}

export const OvaryTestView = ({ form, formPrev, formPrev2, productItem, symptoms }: OvaryTestViewProps) => {
    return (
        <>
            <div style={{ padding: 10 }}>
                <div>状態</div>
                <Flex style={{ fontSize: 14 }}>
                    <CheckboxField form={form} attr={'menstruation'} checkboxLabel="生理中" />
                    <CheckboxField form={form} attr={'pregnancy'} checkboxLabel="妊娠中" />
                </Flex>
            </div>
            <div style={{ padding: 10 }}>
                <div>疑いのある症状</div>

                <div style={{ fontSize: 14 }}>
                    <MultipleSelectField
                        id="ovary-symptoms"
                        form={form}
                        attr="symptoms"
                        selectItems={symptoms.filter((s) => s.products.includes('ovary')).map((s) => s)}
                        hideSearch
                        horizontal
                        hideSelectAll
                    />
                </div>
            </div>
            <div>
                <OvaryControlForm form={form} title="今回" color="#9002" hideEnableCheck productItem={productItem} />
                <OvaryControlForm form={formPrev} title="前回" color="#9002" productItem={productItem} />
                <OvaryControlForm form={formPrev2} title="前々回" color="#9002" productItem={productItem} />
            </div>
        </>
    )
}
type OvaryControlFormProps = {
    form: Form<OvaryTestResultV2Form>
    title: string
    color: string
    hideEnableCheck?: boolean
    productItem: ProductItem
}

const OvaryControlForm = ({ form, title, color, hideEnableCheck, productItem }: OvaryControlFormProps) => {
    const enabled = form.object.enabled
    return (
        <div style={{ padding: 20, backgroundColor: color, width: '100%' }}>
            <Flex style={{}}>
                <div style={{ fontWeight: 'bold' }}>{title}</div>
                {!hideEnableCheck && (
                    <div>
                        <CheckboxField form={form} attr="enabled" checkboxLabel="有効" controlId={title} />
                    </div>
                )}
            </Flex>
            {form.object.enabled && (
                <>
                    <Flex>
                        <DateField form={form} attr="deliveryDate" label="検査日" style={{ marginBottom: 0 }} />
                    </Flex>
                    {form.object.useCt ? (
                        <div>
                            <div style={{ backgroundColor: '#fff5', padding: 5 }}>
                                <div style={{ fontWeight: 'bold' }}>HK</div>
                                <div style={{ padding: 10 }}>
                                    {productItem.qcVersion?.protocolVersionProbes
                                        ?.filter((pvp) => pvp.qcType === 'HK')
                                        .map((pvp, index) => {
                                            return (
                                                <RangeField
                                                    key={'range-' + index}
                                                    form={form}
                                                    attr={['hkCts', pvp.probe!.name!]}
                                                    min={0}
                                                    max={40}
                                                    label={`${pvp.probe?.name} CT =`}
                                                    showValue
                                                    step={0.01}
                                                />
                                            )
                                        })}
                                </div>
                            </div>
                            <div style={{ backgroundColor: '#fff5', marginTop: 10, padding: 5 }}>
                                <div style={{ fontWeight: 'bold' }}>Bio marker</div>
                                <div style={{ padding: 10 }}>
                                    {productItem.currentProtocolVersion?.protocolVersionProbes?.map((pvp, index) => {
                                        return (
                                            <RangeField
                                                key={'range-' + index}
                                                form={form}
                                                attr={['markerCts', pvp.probe!.name!]}
                                                min={0}
                                                max={40}
                                                label={`${pvp.probe?.name} CT =`}
                                                showValue
                                                step={0.01}
                                            />
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <RangeField
                            form={form}
                            attr="baseScore"
                            label="機械学習スコア"
                            min={0}
                            max={1}
                            step={0.001}
                            disabled={!enabled}
                            style={{ marginBottom: 0 }}
                            showValue
                        />
                    )}
                    <RangeField form={form} attr="age" label="年齢" disabled={!enabled} min={0} max={100} step={5} style={{ marginBottom: 0 }} showValue />
                    <Flex>
                        <RangeField
                            form={form}
                            attr="height"
                            label="身長"
                            disabled={!enabled}
                            min={100}
                            max={200}
                            step={5}
                            style={{ marginBottom: 0 }}
                            showValue
                        />
                        <RangeField
                            form={form}
                            attr="weight"
                            label="体重"
                            disabled={!enabled}
                            min={30}
                            max={120}
                            step={5}
                            style={{ marginBottom: 0 }}
                            showValue
                        />
                    </Flex>
                    <Flex>
                        <InputField
                            form={form}
                            attr="birthCount"
                            type="number"
                            label="出産回数"
                            disabled={!enabled}
                            min={0}
                            max={10}
                            style={{ marginBottom: 0 }}
                        />
                        <InputField
                            form={form}
                            attr="takingPillYears"
                            type="number"
                            label="ピル服用年数"
                            disabled={!enabled}
                            min={0}
                            max={30}
                            style={{ marginBottom: 0 }}
                        />
                    </Flex>
                    <Flex style={{ marginTop: 10 }}>
                        <div style={{ marginRight: 50 }}>
                            <div>既往歴</div>
                            <div>
                                <CheckboxField
                                    form={form}
                                    attr="endometriosis"
                                    checkboxLabel="子宮内膜症"
                                    disabled={!enabled}
                                    controlId={title}
                                    style={{ marginBottom: 0 }}
                                />
                                <CheckboxField
                                    form={form}
                                    attr="breastCancer"
                                    checkboxLabel="乳がん"
                                    disabled={!enabled}
                                    controlId={title}
                                    style={{ marginBottom: 0 }}
                                />
                            </div>
                        </div>
                        <div>
                            <div>家族歴</div>
                            <div>
                                <CheckboxField form={form} attr="familyOvary" checkboxLabel="卵巣がん" disabled={!enabled} controlId={title} />
                                <CheckboxField form={form} attr="familyBreast" checkboxLabel="乳がん" disabled={!enabled} controlId={title} />
                            </div>
                        </div>
                    </Flex>
                </>
            )}
        </div>
    )
}
